import   React             from 'react';

import   classNames        from 'classnames';

import   styles            from './not_found.module.scss';


export const NotFound = () => {


  return (
  
        <>

          <div className={classNames(styles.root)}>

            <div className={classNames(styles.contain)}>

	          La page, que vous recherchez, n'existe pas
        
            </div>
            
          </div>
        
        </>
            
  );
};

export default NotFound;
